import { Component, Input, OnInit } from '@angular/core';
import { ErrorDetailsService } from '../../services/error-details.service';
import { IErrorMessages } from 'bi-interfaces';

@Component({
  selector: 'lib-side-bar-error-details',
  templateUrl: './side-bar-error-details.component.html',
  styleUrls: ['./side-bar-error-details.component.scss']
})
export class SideBarErrorDetailsComponent implements OnInit {
  @Input() error!: IErrorMessages | undefined;
  closed = false;
  constructor(public errorDetailsService: ErrorDetailsService) {
  }
  ngOnInit(): void {
  }
  ToggleErrors() {
    // this.error = undefined;
    this.errorDetailsService.showErrorMsg = false;
  }
}
